/**
 * Created by seaasun on 2017/11/24.
 */
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    isInit: false,
    demoType: 1,
    demos: {},
    // items
    // {
    //   // listType
    //   10：{
    //     // demotype
    //     1: {
    //       // column
    //       columnName: {
    //         Values: [
    //         ]
    //       }
    //     }
    //   }
    // }
    selectedDemos: {}, // orderDemos
    phoneOptions: {},
    quickPicks: [],
    recommendDemos: [],
    option: [],
    SICs: [],
    hasQuickPicks: false,
    saveNewQuickPick: false
  },
  getters: {
    fullUrl: state => name => {
      return state.root + state[name]
    },
    isResidentOccupant: state => {
      return state.option.length > 0
    },
    options: state => {
      return state.option
    },
    isTargetoption: state => {
      for (let o of state.option) {
        if (o.key === 'target') {
          return o.values.length > 0
        }
      }
      return false
    },
    isRouteoption: state => {
      for (let o of state.option) {
        if (o.key === 'route') {
          return o.values.length > 0
        }
      }
      return false
    },
    phoneOptions: (state, getters, rootState) => {
      if (rootState.order.ListType === 130) {
        return {
          1: {
            desc: 'Exclude phone numbers',
            value: 1
          }
          // 1: {
          //   desc: 'Do not provide phone numbers',
          //   value: 1
          // },
          // 2: {
          //   desc: 'Provide phone numbers where available(approximately 6-9% will include phone numbers)',
          //   value: 2
          // },
          // 3: {
          //   desc: 'Provide only records with phone numbers (100% will include phone numbers)',
          //   value: 3
          // }
        }
      } else {
        return state.phoneOptions
      }
    },
    noPhoneOption: (state, getters) => {
      return state.isInit && getters.phoneOptions && Object.keys(getters.phoneOptions).length === 0
    },
    isHidePhoneOption (state, getters, rootState) {
      if (rootState.order.ListType === 50) {
        return true
      } else if (state.hasOwnProperty('hidePhoneOption')) {
        return state.hidePhoneOption
      } else {
        return false
      }
    },
    isBusiness: (state, getters, rootState) => {
      let type = rootState.order.ListType
      return [20, 90, 120, 160, 170, 180, 210, 260].indexOf(type) > -1
    }
  },
  mutations: {
    saveDemoType (state, demoType) {
      state.demoType = demoType
    },
    saveListType (state, listType) {
      if (!(listType in state.demos)) {
        Vue.set(state.demos, listType, {})
      }
    },
    saveColumns (state, payload) {
      payload = payload || {}
      let listType = payload.listType || 10
      let demoType = payload.demoType || 1
      let data = payload.data || {}
      if (!(listType in state.demos)) {
        Vue.set(state.demos, listType, {})
      }
      if (!(demoType in state.demos[listType])) {
        Vue.set(state.demos[listType], demoType, {})
      }
      for (let column of data) {
        Vue.set(state.demos[listType][demoType],
          column.ColumnName,
          Object.assign(column, {Values: []})
        )
      }
    },
    saveColumnsValues (state, payload) {
      payload = payload || {}
      let listType = payload.listType || 10
      let demoType = payload.demoType || 1
      let data = payload.data || {}
      // check list type
      if (!(listType in state.demos)) {
        Vue.set(state.demos, listType, {})
      }
      // check demo type
      if (!(demoType in state.demos[listType])) {
        Vue.set(state.demos[listType], demoType, {})
      }
      // Add column
      let demos = state.demos[listType][demoType]
      for (let item of data) {
        if (demos.hasOwnProperty(item.ColumnName)) {
          demos[item.ColumnName].Values.push(item)
        } else {
          Vue.set(demos, item.ColumnName, {
            ColumnName: item.ColumnName,
            AttributeName: item.AttributeName,
            AttributeDesc: item.AttributeDesc,
            Values: [item]
          })
        }
      }
    },
    saveAttributes (state, payload) {
      payload = payload || {}
      let listType = payload.listType || 10
      let demoType = payload.demoType || 1
      let columnName = payload.columnName || ''
      let demoCategory = payload.demoCategory || 1
      let data = payload.data || []
      // TODO@pony need check key
      let column = state.demos[listType][demoType][columnName]
      for (let i = 0; i < data.length; i++) {
        data[i].DemoCategory = demoCategory
      }
      column.Values = data
    },
    deleteDemo (state, payload) {
      payload = payload || {}
      let type = payload.type || 'attribute'
      let columnName = payload.columnName
      let attributeValue = payload.attributeValue

      // delete column
      if (type === 'column') {
        Vue.delete(state.selectedDemos, columnName)
      } else {
        let column = state.selectedDemos[columnName]

        // delete column if attribute.length == 1
        if (column.Values.length === 1) {
          Vue.delete(state.selectedDemos, columnName)

          // delete attribute
        } else {
          for (let i = 0; i < column.Values.length; i++) {
            if (attributeValue === column.Values[i].AttributeValue) {
              Vue.delete(state.selectedDemos[columnName].Values, i)
              break
            }
          }
        }
      }
    },
    savePhoneOptions: function (state, items) {
      Vue.set(state, 'phoneOptions', {})
      let descs = {
        '1': "I don't need phone numbers.",
        '2': "I'll take those with and without phone numbers. Only about 5% will have phone numbers.",
        '3': 'I only want leads with phone numbers.'
      }
      for (let item of items[0]) {
        let val = item.SettingValue
        let desc = descs[item.SettingValue]
        if (val === '2' && [20, 90, 120, 160, 170, 180, 210, 260].indexOf(items[1]) > -1) {
          desc = "I'll take those with and without phone numbers."
        }
        Vue.set(state.phoneOptions, val, {
          value: val,
          desc: desc
        })
      }
    },
    saveQuickPicks (state, payload) {
      state.quickPicks = payload
    },
    saveKey (state, val) {
      Vue.set(state, val[0], val[1])
    },
    setDemoAccess (state, values) {
      state.types[values.type].access = values.val
    },
    saveoption (state, payload) {
      if (state.option.length === 0) {
        state.option = [{title: '', key: 'target', values: []}, {title: '', key: 'route', values: []}]
      }
      for (let i = 0; i < state.option.length; i++) {
        if (state.option[i].key === payload.key) {
          Vue.set(state.option, i, payload)
        }
      }
    },
    removeoption (state, payload) {
      for (let o of state.option) {
        if (o.key === payload.key) {
          for (var val = 0; val < o.values.length; val++) {
            if (o.values[val] === payload.val) {
              Vue.delete(o, val)
            }
          }
        }
      }
    }
  },

  actions: {
    init ({state, commit}, listType) {
      commit('saveKey', ['isInit', false])

      // request demo init
      Vue.http.post('PlaceOrder.aspx/GetDemoOptionsAndQuickPickups', {
        demotype: 2,
        listtype: listType
      }).then(resp => {
        commit('saveKey', ['isInit', true])

        let data = resp.body.d.DataSource
        // init phoneOption
        commit('savePhoneOptions', [data.PhoneOptions.AvailablePhoneOptions, listType])
        commit('order/savePhoneOption', data.PhoneOptions.DefaultCheckedPhoneOption, {root: true})

        commit('saveKey', ['existAnicoTabs', data.ExistAnicoTabs]) // TODO@PONY doesn't find this tab
        commit('saveKey', ['existAudiencePropensity', data.ExistAudiencePropensity])
        commit('saveKey', ['existCharitableGiving', data.ExistCharitableGiving]) // TODO@PONY there is no CharitableGiving
        commit('saveKey', ['existQuickPicks', data.ExistQuickPicks])
        commit('saveKey', ['hidePhoneOption', data.HidePhoneOption]) // TODO@PONY need fix phone option
        commit('saveKey', ['lifeStyle', data.LifeStyle])
        commit('saveKey', ['allHouseholdSetting', data.AllHouseholdSetting])
        if (!data.ExistQuickPicks) {
          commit('config/deleteTabType', ['quickPicks', 'demoTabs', listType], {root: true})  // need save quick pick
        }
        commit('saveKey', ['hasQuickPicks', data.ExistQuickPicks])
        commit('config/saveDatasourceKey', ['hasQuickPick'], {root: true})
        if (!data.ExistAudiencePropensity) {
          commit('config/deleteTabType', ['audiencePropensities', 'demoTabs', listType], {root: true})
        }
        if (data.LifeStyle.length === 0) {
          commit('config/deleteTabType', ['intrestsPurchasing', 'demoTabs', listType], {root: true})
        }
        if (data.HidePhoneOption) {
          commit('saveKey', ['hasPhoneOption', !data.HidePhoneOption])
          let phoneOption = data.PhoneOptions.DefaultCheckedPhoneOption || 1  // TODO@PONY need check
          commit('order/saveKey', ['PhoneOption', phoneOption], {root: true})
        }
        if (data.MinQuantity > 0) {
          setTimeout(() => {
            commit('site/saveKey', ['MinQuantityOfOrder', data.MinQuantity], {root: true})
          }, 5000)
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/demo/index.js